var $cookie = {
	set: function(name,value,days) {
		var expires;
		if (days) {
			var date = new Date();
			date.setTime(date.getTime()+(days*24*60*60*1000));
			expires = "; expires="+date.toGMTString();
		}
		else expires = "";
		document.cookie = name+"="+value+expires+"; path=/";
	},
	get: function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
		}
		return null;
	},
	delete: function(name) {
		$cookie.set(name,"",-1);
	},
	decodePrs: function(prsStr) {
		if (!prsStr) return;
	    var prs = {};
	    prsStr.replace(/\|?([^\|=]+)=([^\|]*)/gi, function(m,key,value) {
	        prs[key] = value;
	    });
	    return prs;
	},
	encodePrs: function(prsObj) {
		return Object.keys(prsObj)
			.map(function(k) { return k + '=' + prsObj[k];}).join('|');
	},
	updatePrsCookie: function(params) {
		var prsObj = $cookie.decodePrs($cookie.get('prs')) || {};
		for (var key in params) {
			if (params.hasOwnProperty(key)) {
				prsObj[key] = params[key];
			}
		}
		var prsStr = $cookie.encodePrs(prsObj);
		$cookie.set('prs', encodeURIComponent(prsStr));

		prsObj = $cookie.decodePrs($cookie.get('prsps')) || {};
		for (key in params) {
			if (params.hasOwnProperty(key)) {
				prsObj[key] = params[key];
			}
		}
		prsStr = $cookie.encodePrs(prsObj);
		$cookie.set('prsps', encodeURIComponent(prsStr), 30);
	}
};
